import React from "react";

export const DeleteTextIcon = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      data-testid="deleteTextIcon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM4.75402 12C4.34023 12 4 11.6506 4 11.2276C4 11.0253 4.08276 10.8414 4.22069 10.6943L6.91494 8L4.22069 5.30575C4.08276 5.15862 4 4.97471 4 4.77241C4 4.34943 4.34023 4.01839 4.75402 4.01839C4.97471 4.01839 5.14943 4.09195 5.28736 4.23908L7.9908 6.93333L10.7218 4.22989C10.8782 4.07356 11.0437 4 11.246 4C11.6598 4 12 4.34023 12 4.75402C12 4.96552 11.9356 5.13103 11.7793 5.29655L9.07586 8L11.7701 10.6851C11.9172 10.8414 11.9908 11.0161 11.9908 11.2276C11.9908 11.6506 11.6506 12 11.2276 12C11.0161 12 10.8322 11.908 10.6851 11.7701L7.9908 9.07586L5.31494 11.7701C5.16782 11.9172 4.97471 12 4.75402 12Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};
